<template>
  <div id="toTop"></div>
</template>
<script>
import $ from "jquery";
export default {
  name: "PdkToTop",
  mounted: function() {
    const vm = this;
    var pxShow = 800; // height on which the button will show
    var scrollSpeed = 500; // how slow / fast you want the button to scroll to top.

    $(window).scroll(function() {
      if ($(window).scrollTop() >= pxShow) {
        $(vm.$el).addClass("visible");
      } else {
        $(vm.$el).removeClass("visible");
      }
    });

    $(vm.$el).on("click", function() {
      $("html, body").animate({ scrollTop: 0 }, scrollSpeed);
      return false;
    });
  }
};
</script>